import { useStaffingAgencyPocTypes, useTimezones } from 'src/queries'

export interface UseLookupsReturn {
  types: ReturnType<typeof useStaffingAgencyPocTypes>
  timezones: ReturnType<typeof useTimezones>
}

const DefaultLookupsReturn: UseLookupsReturn = {
  types: [],
  timezones: []
}

const useLookups = (): UseLookupsReturn => {
  const types = useStaffingAgencyPocTypes()
  const timezones = useTimezones()
  return {
    types,
    timezones
  }
}

export default useLookups
export { DefaultLookupsReturn }
